module.exports = "<router-outlet></router-outlet>\n<ng2-toasty [position]=\"'top-right'\"></ng2-toasty>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main